<script lang="ts">
  import type { LayoutType } from '@shared/lib';
  import { type ToggleButtonItem, layoutType, layoutTypeMobile } from '@shared/lib/stores/layouts';
  import { Toggle } from '@shared/ui/toggle';

  const setSelectedLayout = (type: LayoutType): void => {
    $layoutType = type;
  };
  const setSelectedLayoutMobile = (type: LayoutType): void => {
    $layoutTypeMobile = type;
  };

  const toggleList: ToggleButtonItem[] = [
    {
      value: 'relative',
      icon: 'masonry',
    },
    {
      value: 'masonry',
      icon: 'gridNine',
    },
  ];

  const toggleListMobile: ToggleButtonItem[] = [
    {
      value: 'single',
      icon: 'linesHorizontal',
    },
    {
      value: 'masonry',
      icon: 'linesVertical',
    },
  ];
</script>

<div class="hidden md:block">
  <Toggle {toggleList} value="{$layoutType}" on:change="{(e) => setSelectedLayout(e.detail)}" />
</div>

<div class="block md:hidden">
  <Toggle
    toggleList="{toggleListMobile}"
    value="{$layoutTypeMobile}"
    on:change="{(e) => setSelectedLayoutMobile(e.detail)}"
    isConsistent
  />
</div>
